'use strict'

export default {}
